/**
 * Central design tokens extracted from the Chunaav Figma file.
 * Mirror of the values in tailwind.config.js so they can be used
 * from TS (e.g. Ant Design theme, inline styles) as well.
 */
export const colors = {
  white: '#FFFFFF',
  brand: '#0061FF', // CTA & Highlight
  brandDark: '#004AC6', // Logo / active
  brandShade: '#EEF4FF', // Highlight shade
  bg: '#F7FAFF', // App background
  textPrimary: '#00173E',
  textSecondary: '#46556F',
  ink900: '#191B23',
  ink700: '#434655',
  line: '#C3C6D7',
  lineSoft: '#E2E8F0',
  avatarBg: '#D0E1FB',
  avatarBg2: '#D3E4FE',
  mutedBg: '#F3F3F3',
} as const;

export const fontFamily =
  "'Inter', system-ui, 'Segoe UI', Roboto, sans-serif";
